import * as tslib_1 from "tslib";
import { OnInit } from "@angular/core";
import { Validators } from "@angular/forms";
import { Subscription } from "rxjs";
import { Alert } from "src/app/shared/class/Alert";
export class UmovmeEnvironmentDetailsComponent {
    constructor(spinner, service, route, router, fb) {
        this.spinner = spinner;
        this.service = service;
        this.route = route;
        this.router = router;
        this.fb = fb;
        this.subscription = new Subscription();
        this.goback = "../list/";
        this.queryParams = {};
        this.hideToken = true;
    }
    ngOnInit() {
        try {
            this.spinner.show();
            this.form = this.fb.group({
                id: this.fb.control(""),
                name: this.fb.control("", [Validators.required]),
                token: this.fb.control("", [Validators.required]),
                default: this.fb.control(false, [Validators.required]),
                active: this.fb.control(false, [Validators.required]),
            });
            this.route.queryParams.subscribe((params) => {
                this.queryParams = params;
                this.load();
            });
            this.spinner.hide();
        }
        catch (error) {
            this.spinner.hide();
        }
    }
    load() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                if (this.queryParams.id) {
                    this.spinner.show();
                    this.subscription.add(this.service.detail(this.queryParams.id).subscribe((res) => {
                        this.form.patchValue(res.data);
                        this.spinner.hide();
                    }, () => {
                        this.spinner.hide();
                        Alert.error(Alert.getMessage().errors.load);
                    }));
                }
            }
            catch (error) {
                this.spinner.hide();
                Alert.error(Alert.getMessage().errors.load).then(() => this.router.navigate([this.goback]));
            }
        });
    }
    onSubmit() {
        if (this.form.valid) {
            const action = this.form.value.id > 0
                ? this.service.update(this.form.value)
                : this.service.save(this.form.value);
            this.subscription.add(action.subscribe(() => {
                this.spinner.hide();
                Alert.success(Alert.getMessage().success.save).then(() => this.router.navigate([this.goback]));
            }, () => {
                this.spinner.hide();
                Alert.error(Alert.getMessage().errors.save);
            }));
        }
        else {
            console.log(this.form.valid);
            console.log(this.form.value);
        }
    }
}
